<script setup lang="ts">
import { locale_float } from '~/types/shared'

const props = defineProps<{
	row: any
}>()

</script>

<template>
	<div class="space-y-1 text-zinc-800 dark:text-zinc-300" v-if="row.fees_processing_result">
		<p class="text-green-600">{{ $t('project-profit') }}: {{ locale_float(row.fees_processing_result?.project_final_profit_usdt_total) }} USDT</p>

		<p class="text-yellow-600">{{ $t('partners_profit_total') }}: {{ locale_float(row.fees_processing_result?.partners_profit_usdt_total) }} USDT</p>

		<p>{{ $t('project_card_issue_price') }} {{ locale_float(row.fees_processing_result?.project_card_issue_price_usdt) }} USDT</p>
		<p>{{ $t('topup_fixed_fee') }} (TRC20): {{ locale_float(row.fees_processing_result?.provider_trc20_topup_fixed_fee_amount_usdt) }} USDT</p>
	</div>
</template>
